import type { InvoiceLookup, SiteConfig } from "../lib/gboModels";
import { getInvoiceViewModel } from "../features/invoices/invoiceViewModel";
import { selectCanAttemptCheckout } from "../features/checkout/checkoutSelectors";
import { getPaymentProviderLabel } from "../features/checkout/payment";

export function getAnonymousInvoiceViewModel(lookup: InvoiceLookup, site: SiteConfig) {
  const viewModel = getInvoiceViewModel(lookup.invoice);
  return {
    ...viewModel,
    paymentRail: {
      ...viewModel.paymentRail,
      canPay: selectCanAttemptCheckout(
        lookup.payment,
        site.payOnlineEnabled,
        lookup.accountBalance,
        lookup.invoice,
      ),
    },
    paymentPanel: {
      invoice: lookup.invoice,
      customerId: lookup.invoice.customerId,
      accountBalance: lookup.accountBalance,
      payment: lookup.payment,
      payOnlineEnabled: site.payOnlineEnabled,
    },
    paymentProviderLabel: getPaymentProviderLabel(lookup.payment),
  };
}
